module.exports = __webpack_public_path__ + "media/images/universe_landing_pages/hero_banner/component/massage-mobile@3x-69b36b54ab56ca13c4bb9060ec2a1864.jpg";